<template>

    <div :class="styleClass">        
        <a href="#" @click.prevent="click()"
           
           :data-teaser="teaser.data" :data-id="teaser.teaser_id" :data-index="teaser.index" :data-position="teaser.position"
           class="vertical">
                    <div class="vertical__wrap-img" v-if="!!teaser.video">
                         <video playsinline class="vertical__img"  autoplay :poster="teaser.path_rectangle_image"  muted loop>
            				<source :src="getVideoFile" :type="getVideoTypeFile">
    					</video>
    				</div>    
            		<div class="vertical__wrap-img"  v-else>
                        <img :src="teaser.path_rectangle_image" ref="img" class="vertical__img" v-bind="crossorigin">
                    </div>
                    <div class="vertical__wrap-content">
                        <h5 class="vertical__title"> {{teaser.title}}</h5>
                        <div class="vertical__description" v-if="teaser.description && teaser.description.length > 0">{{teaser.description}}</div>
                        <div class="indent"></div>
                        <div class="vertical__bottom" v-if="publicationTime != '' && isModeration === 1">
                            <i class="fa fa-calendar-o"></i>
                            <span class="vertical__date">{{publicationTime}}</span>
    					</div>
           </div>    		
        </a>
    </div>

</template>

<script>
    import FastAverageColor from 'fast-average-color';




    export default {
        name: "teaser4",
        props:{
            styleClass:String,
            teaser:Object,
            square:{
                type:Boolean,
                default:false,
            },
            position:{
                type:Number,
                default:0,
            },

        },
        data() {
            return {
                gradientStyle:{},
                style:{},
                size: 50,
                publicationTime:'',
                isModeration: window.config.is_moderated,
            };
        },
        mounted() {
            let ago = Math.floor(Math.random() * (24 + 1) - 1);
            
            if (ago == 1 || ago == 21) this.publicationTime = ago + " " + this.Helper.t("hour_ago1","час назад");
                else if ((ago > 1 && ago < 5) || (ago > 21)) this.publicationTime = ago + " "+ this.Helper.t("hour_ago2", "часа назад");
                else if (ago > 4 && ago < 21) this.publicationTime = ago + " " +  this.Helper.t("hour_ago3", "часов назад");
                else this.publicationTime = "1 " + this.Helper.t("hour_ago1", "час назад");   
            

            this.style = {
                background: 'rgb(17, 12, 9)',
                color:      'white',
            };

            this.gradientStyle  = {background: 'linear-gradient(rgba(17, 12, 9, 0) 0%, rgb(17, 12, 9) 100%)'};
            
            
                let img = this.$refs.img;
            // img.crossorigin = '';
            let vue = this;
            img.addEventListener('load', function()
            {
                                
                
//             let ago = Math.floor(Math.random() * (24 + 1) - 1);
            
//             if (ago == 1 || ago == 21) vue.publicationTime = ago + " час назад";
//             else if ((ago > 1 && ago < 5) || (ago > 21)) vue.publicationTime = ago + " часа назад";
//             else if (ago > 4 && ago < 21) vue.publicationTime = ago + " часов назад";
//             else vue.publicationTime = "1 час назад";
                
//             if (ago == 1 || ago == 21) vue.publicationTime = ago + " " + vue.Helper.t("hour_ago1","час назад");
//                 else if ((ago > 1 && ago < 5) || (ago > 21)) vue.publicationTime = ago + " "+ vue.Helper.t("hour_ago2", "часа назад");
//                 else if (ago > 4 && ago < 21) vue.publicationTime = ago + " " +  vue.Helper.t("hour_ago3", "часов назад");
//                 else vue.publicationTime = "1 " + vue.Helper.t("hour_ago1", "час назад");    
                
                
                

			
                
                if (vue.teaser.is_rtb == 1) return;

                let height = this.naturalHeight;
                let color;
                if (!window.teasersColor[img.src]) {
                    let fac = new FastAverageColor();
                    color = fac.getColor(this, {top: height - vue.size, height: vue.size});

                    window.teasersColor[img.src] = color;
                } else {
                    color = window.teasersColor[img.src];
                }


                if (color.value) {
                    var colorEnd = [].concat(color.value.slice(0, 3), 0).join(',');
                    vue.style = {
                        background: color.rgb,
                        color:      color.isDark ? 'white' : 'black',
                    };

                    vue.gradientStyle  = {background: 'linear-gradient(to bottom, ' +
                            'rgba(' + colorEnd + ') 0%, ' + color.rgba + ' 100%)'};
                }
            }, false)
            


        },
        methods:{
            click(){
//                 this.teaser.position = this.position;
                this.Helper.adClick(this, this.teaser, true);
            }
        },
        computed: {
              crossorigin(){

               if (this.teaser.is_rtb == 0) {
                   return {crossorigin:'anonymous'};
               }

                return {};
            },
            getVideoFile() {               
                console.log('this.teaser.video.ad.in_line.creatives.creative[0].linear',this.teaser.video.ad.in_line.creatives.creative[0].linear);
                    return this.teaser.video.ad.in_line.creatives.creative[0].linear.media_files.media_file[0].cdata || "";
               
            },
            getVideoTypeFile() {
               		
                    return this.teaser.video.ad.in_line.creatives.creative[0].linear.media_files.media_file[0].type || '';
            }
        }

    }
</script>

<style>
    .teaser4 > a.video {
        display:flex !important;
    }
</style>